import styled from "styled-components";
import {GameHeaderBarRootBaseBox} from "../../../common/boxes/root/game-header-bar-root-base.box";

export const GameDetailHistoryHeaderBarRootBox = styled(GameHeaderBarRootBaseBox)`
  font-size: 1.5rem;
  @media ${props => props.theme.mediaQuery.sAndBelow} {
    font-size: 1rem;
  }
  
`